import { Link } from 'react-router-dom';
import CTAButton from '../components/CTAButton';
import { INDUSTRIES_DETAILED } from '../constant/data';

const INDUSTRIES = INDUSTRIES_DETAILED;
function IndustryBlock({ industry, index }) {
  const { icon, title, description, capabilities, sidebarIcon, sidebarTitle, sidebarBody, reverse } = industry;

  const mainCol = (
    <div className={`col-lg-7 mb-4 mb-lg-0${reverse ? ' order-lg-0' : ''}`}>
      <div className="industry-detail">
        <div className="industry-detail-icon"><i className={icon} /></div>
        <h3>{title}</h3>
        <p style={{ color: 'var(--ink-2)', fontSize: '0.95rem', lineHeight: '1.75', marginBottom: '1.25rem' }}>{description}</p>
        <ul className="check-list mt-3">
          {capabilities.map(c => (
            <li key={c}><i className="fas fa-check" />{c}</li>
          ))}
        </ul>
        <div className="mt-4">
          <Link
            to="/contact"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '0.4rem',
              fontSize: '0.85rem',
              fontWeight: 700,
              color: 'var(--ink-1)',
              border: '1.5px solid var(--border-1)',
              borderRadius: 6,
              padding: '0.5rem 1.1rem',
              textDecoration: 'none',
              transition: 'all 0.2s',
            }}
          >
            Talk to us about {title.toLowerCase()} <i className="fas fa-arrow-right" style={{ fontSize: '0.7rem' }} />
          </Link>
        </div>
      </div>
    </div>
  );

  const sideCol = (
    <div className={`col-lg-4${reverse ? ' mb-4 mb-lg-0 order-lg-1 offset-lg-1' : ' offset-lg-1'}`}>
      <div className="industry-sidebar-card">
        <i className={`${sidebarIcon} industry-sidebar-icon`} />
        <h5>{sidebarTitle}</h5>
        <p>{sidebarBody}</p>
      </div>
    </div>
  );

  return (
    <>
      {index > 0 && <hr className="section-divider" />}
      <section className="section-corporate">
        <div className="container">
          <div className="row align-items-center">
            {reverse ? [sideCol, mainCol] : [mainCol, sideCol]}
          </div>
        </div>
      </section>
    </>
  );
}

function Industries() {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <div className="breadcrumb-nav">
            <Link to="/">Home</Link>
            <span>/</span>
            Industries
          </div>
          <h1>Who We Work With</h1>
          <p>
            We work across government, NGOs, financial services, tourism, and private sector — anywhere
            that needs reliable systems and someone to stand behind them.
          </p>
        </div>
      </section>

      {INDUSTRIES.map((ind, i) => (
        <IndustryBlock key={ind.title} industry={ind} index={i} />
      ))}

      <section className="cta-section">
        <div className="container text-center position-relative">
          <h2>Work in a different sector?</h2>
          <p>
            If you don't see your industry listed, get in touch anyway. We've worked on enough
            different projects that we can usually figure out the right approach.
          </p>
          <CTAButton type="gold" to="/contact">Get in Touch</CTAButton>
        </div>
      </section>
    </>
  );
}

export default Industries;
